// extracted by mini-css-extract-plugin
export default {"order__aside":"OrderAside_order__aside__kJf5+"};